import { applyFilter } from "~Shared/hooks/filter.hooks"
import { getTableFilterObjectStore } from "~Shared/hooks/table.hooks"
import { REACT_QUERY_FILTER_TABLES } from "~Shared/queries/filter.queries"

export const subscribeToFilter = (data: any) => {
    const { table } = data.fullDocument.metaData.updatedFields
    const newFilterObj = data.fullDocument.metaData.updatedFields.parameters ?? {}
    if (REACT_QUERY_FILTER_TABLES.includes(table)) {
        return
    }

    applyFilter(table, newFilterObj, undefined, false)
}

export const isIncomingFilterEqualToLocal = (incomingSocketData: any) => {
    const { table } = incomingSocketData.fullDocument.metaData.updatedFields
    const newFilterObj = incomingSocketData.fullDocument.metaData.updatedFields.parameters
    if (REACT_QUERY_FILTER_TABLES.includes(table)) {
        return true
    }
    const oldFilterObject = getTableFilterObjectStore(table)
    return JSON.stringify(newFilterObj) === JSON.stringify(oldFilterObject)
}
